(() => {
  const featuredImage = document.querySelector(
    ".js-media-gallery__featured-image"
  );

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data.variant;
    if (variant.featured_image) {
      featuredImage.src = variant.featured_image.src;
      featuredImage.srcset = variant.featured_image.src;
    }
  });
})();
